<template>
    <div class="timeline animated">
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 30</small>4:53 PM</div>
            <div class="timeline-icon">
                <div class="bg-primary"><i class="fa fa-pencil"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is a title for this timeline post</h2>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 25</small>6:14 PM</div>
            <div class="timeline-icon">
                <div class="bg-warning"><i class="fa fa-quote-right"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <blockquote>
                        <p>Lorem ipsum velit ullamco anim pariatur proident eu deserunt laborum. Lorem ipsum ad in nostrud adipisicing cupidatat anim officia ad id cupidatat veniam quis elit ullamco</p>
                        <small>John Smith</small></blockquote>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 16</small>9:00 AM</div>
            <div class="timeline-icon">
                <div class="bg-info"><i class="fa fa-camera"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is an image posted on my timeline</h2>
                    <img class="img-responsive" src="http://www.17sucai.com/upload/258094/2014-12-24/b9e8f2eb5de0546c6897c59568ed2565_big.png">
                    <p>Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 12</small>1:14 PM</div>
            <div class="timeline-icon">
                <div class="bg-primary"><i class="fa fa-video-camera"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is a title for this timeline post</h2>
                    <div class="video-container"><iframe allowfullscreen="" frameborder="0" mozallowfullscreen="" src="https://player.vimeo.com/video/16202331?title=0&amp;byline=0&amp;portrait=0" webkitallowfullscreen=""></iframe></div>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 10</small>4:53 PM</div>
            <div class="timeline-icon">
                <div class="bg-primary"><i class="fa fa-pencil"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is a title for this timeline post</h2>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 9</small>6:14 PM</div>
            <div class="timeline-icon">
                <div class="bg-warning"><i class="fa fa-quote-right"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <blockquote>
                        <p>Lorem ipsum velit ullamco anim pariatur proident eu deserunt laborum. Lorem ipsum ad in nostrud adipisicing cupidatat anim officia ad id cupidatat veniam quis elit ullamco</p>
                        <small>John Smith</small>
                    </blockquote>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 6</small>9:00 AM</div>
            <div class="timeline-icon">
                <div class="bg-info"><i class="fa fa-camera"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is an image posted on my timeline</h2>
                    <img class="img-responsive" src="http://www.17sucai.com/upload/224021/2014-11-17/e73c91e226b6a88b5e5c97aa336996ca_big.jpg">
                    <p>Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
        
        <div class="timeline-row active">
            <div class="timeline-time"><small>Oct 2</small>1:14 PM</div>
            <div class="timeline-icon">
                <div class="bg-primary"><i class="fa fa-video-camera"></i></div>
            </div>
            <div class="panel timeline-content">
                <div class="panel-body">
                    <h2>This is a title for this timeline post</h2>
                    <div class="video-container"><iframe src="http://www.56.com/iframe/MTE0MTEwNjc2" width="320" height="270" frameborder="0" allowfullscreen=""></iframe></div>
                    <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Phasellus hendrerit. Pellentesque aliquet nibh nec urna. In nisi neque, aliquet vel, dapibus id, mattis vel, nisi. Sed pretium, ligula sollicitudin laoreet viverra, tortor libero sodales leo, eget blandit nunc tortor eu nibh. Nullam mollis. Ut justo. Suspendisse potenti.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    mounted(){
        (function() {
            $(document).ready(function() {
                var timelineAnimate;
                timelineAnimate = function(elem) {
                    return $(".timeline.animated .timeline-row").each(function(i) {
                        var bottom_of_object, bottom_of_window;
                        bottom_of_object = $(this).position().top + $(this).outerHeight();
                        bottom_of_window = $(window).scrollTop() + $(window).height();
                        if (bottom_of_window > bottom_of_object) {
                        return $(this).addClass("active");
                        }
                    });
                };
                timelineAnimate();
                return $(window).scroll(function() {
                    return timelineAnimate();
                });
            });
        }).call(this);
    }
}
</script>

<style lang="less" scoped>
.timeline{
    font-family: "Source Sans Pro", sans-serif;
    .bg-warning {
        background-color: #ef9544;
    }
    .bg-info {
        background-color: #5bc0de;
    }
}
.timeline {
  list-style: none;
  position: relative;
  max-width: 1200px;
  padding: 20px;
  margin: 0 auto;
  overflow: hidden; }

  .timeline:after {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -2px;
    background-color: rgba(0, 0, 0, 0.2);
    height: 100%;
    width: 4px;
    border-radius: 2px;
    display: block; }
  .timeline .timeline-row {
    padding-left: 50%;
    position: relative;
    z-index: 10; }
    .timeline .timeline-row .timeline-time {
      position: absolute;
      right: 50%;
      top: 31px;
      text-align: right;
      margin-right: 40px;
      font-size: 16px;
      line-height: 1.3;
      font-weight: 600; }
      .timeline .timeline-row .timeline-time small {
        display: block;
        color: white;
        text-transform: uppercase;
        opacity: 0.75;
        font-size: 11px;
        font-weight: 400; }
    .timeline .timeline-row .timeline-icon {
      position: absolute;
      top: 30px;
      left: 50%;
      margin-left: -20px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: white;
      text-align: center;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      overflow: hidden;
      padding: 3px;
      color: white;
      font-size: 14px;
      z-index: 100; }
      .timeline .timeline-row .timeline-icon > div {
        border-radius: 50%;
        display: -webkit-box;
		-webkit-box-pack: center;
		box-pack: center;
		-webkit-box-align: center;
		box-align: center;
        font-size: 27px; 
		width:34px;
		height:34px;
	}
    .timeline .timeline-row .timeline-content {
      margin-left: 40px;
      position: relative;
      background-color: white;
      color: #333333; }
      .timeline .timeline-row .timeline-content:after {
        content: "";
        position: absolute;
        top: 48px;
        left: -41px;
        height: 4px;
        width: 40px;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: -1; }
      .timeline .timeline-row .timeline-content .panel-body {
        padding: 15px 15px 2px;
        position: relative;
        z-index: 10; 
		box-shadow:0 0 10px #999999;
		border-radius: 10px;
		}
      .timeline .timeline-row .timeline-content h2 {
        font-size: 22px;
        margin-bottom: 12px;
        margin-top: 0;
        line-height: 1.2; }
      .timeline .timeline-row .timeline-content p {
        margin-bottom: 15px; }
      .timeline .timeline-row .timeline-content img {
        margin-bottom: 15px; }
      .timeline .timeline-row .timeline-content blockquote {
        border-color: #eeeeee; }
        .timeline .timeline-row .timeline-content blockquote footer, .timeline .timeline-row .timeline-content blockquote small, .timeline .timeline-row .timeline-content blockquote .small, .timeline .timeline-row .timeline-content blockquote.blockquote-reverse footer, .timeline .timeline-row .timeline-content blockquote.blockquote-reverse small, .timeline .timeline-row .timeline-content blockquote.blockquote-reverse .small {
          color: #999999; }
      .timeline .timeline-row .timeline-content .video-container {
        position: relative;
        padding-bottom: 56.25%;
        padding-top: 30px;
        height: 0;
        margin-bottom: 15px;
        overflow: hidden; }
        .timeline .timeline-row .timeline-content .video-container iframe, .timeline .timeline-row .timeline-content .video-container object, .timeline .timeline-row .timeline-content .video-container embed {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%; }
    .timeline .timeline-row:nth-child(odd) {
      padding-left: 0;
      padding-right: 50%; }
      .timeline .timeline-row:nth-child(odd) .timeline-time {
        right: auto;
        left: 50%;
        text-align: left;
        margin-right: 0;
        margin-left: 40px; }
      .timeline .timeline-row:nth-child(odd) .timeline-content {
        margin-right: 40px;
        margin-left: 0; }
        .timeline .timeline-row:nth-child(odd) .timeline-content:after {
          left: auto;
          right: -41px; }
  .timeline.animated .timeline-row .timeline-content {
    opacity: 0;
    left: 20px;
    -webkit-transition: all 0.8s;
    -moz-transition: all 0.8s;
    transition: all 0.8s; }
  .timeline.animated .timeline-row:nth-child(odd) .timeline-content {
    left: -20px; }
  .timeline.animated .timeline-row.active .timeline-content {
    opacity: 1;
    left: 0; }
  .timeline.animated .timeline-row.active:nth-child(odd) .timeline-content {
    left: 0; }

@media (max-width: 1200px) {
  .timeline {
    padding: 15px 10px; }
    .timeline:after {
      left: 28px; }
    .timeline .timeline-row {
      padding-left: 0;
      margin-bottom: 16px; }
      .timeline .timeline-row .timeline-time {
        position: relative;
        right: auto;
        top: 0;
        text-align: left;
        margin: 0 0 6px 56px; }
        .timeline .timeline-row .timeline-time strong {
          display: inline-block;
          margin-right: 10px; }
      .timeline .timeline-row .timeline-icon {
        top: 52px;
        left: -2px;
        margin-left: 0; }
      .timeline .timeline-row .timeline-content {
        margin-left: 56px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
        position: relative; }
        .timeline .timeline-row .timeline-content:after {
          right: auto !important;
          left: -20px !important;
          top: 32px; }
      .timeline .timeline-row:nth-child(odd) {
        padding-right: 0; }
        .timeline .timeline-row:nth-child(odd) .timeline-time {
          position: relative;
          right: auto;
          left: auto;
          top: 0;
          text-align: left;
          margin: 0 0 6px 56px; }
        .timeline .timeline-row:nth-child(odd) .timeline-content {
          margin-right: 0;
          margin-left: 55px; }
    .timeline.animated .timeline-row:nth-child(odd) .timeline-content {
      left: 20px; }
    .timeline.animated .timeline-row.active:nth-child(odd) .timeline-content {
      left: 0; } }
</style>